import React, { useState } from 'react';
import { optimizeImage } from '../lib/cms';

export default function VideoFacade({
  videoUrl,
  coverImage,
  title,
  duration,
  className = '',
}) {
  const [isPlaying, setIsPlaying] = useState(false);

  const poster = coverImage?.[0] || 'https://assets.auxodev.dk/assets/73686664-eff4-4605-b977-e635729d5a69/presse-studie-debat-skatunderlup.jpg';

  // Normalize embed URL
  let embedSrc = videoUrl;
  if (videoUrl && videoUrl.includes('youtube.com/watch?v=')) {
    const videoId = videoUrl.split('v=')[1]?.split('&')[0];
    embedSrc = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`;
  } else if (videoUrl && !videoUrl.includes('autoplay=1')) {
    embedSrc = videoUrl.includes('?') ? `${videoUrl}&autoplay=1` : `${videoUrl}?autoplay=1`;
  }

  return (
    <div className={`relative overflow-hidden rounded-md border border-slate-200 bg-[#010b27] shadow-xs ${className}`}>
      {isPlaying ? (
        <div className="relative aspect-video w-full">
          <iframe
            src={embedSrc}
            title={title || 'Video afspiller'}
            className="h-full w-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      ) : (
        <div className="group relative aspect-video w-full overflow-hidden cursor-pointer" onClick={() => setIsPlaying(true)}>
          <img
            src={optimizeImage(poster, { width: 1200 })}
            alt={title || 'Videocover'}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105 opacity-90"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/20 transition-colors group-hover:from-black/70" />

          {/* Centered Play Button */}
          <button
            type="button"
            className="absolute inset-0 m-auto flex h-16 w-16 sm:h-20 sm:w-20 items-center justify-center rounded-full bg-[#fd7302] text-white shadow-xl transition-all duration-300 group-hover:scale-110 group-hover:bg-[#e06500] focus:outline-none focus:ring-4 focus:ring-white/40"
            aria-label={`Afspil video: ${title || 'Video'}`}
          >
            <i className="fa-solid fa-play ml-1 text-xl sm:text-2xl" aria-hidden="true" />
          </button>

          {/* Duration Badge */}
          {duration && (
            <div className="absolute top-3 right-3 rounded-xs bg-[#010b27]/85 px-2.5 py-1 text-xs font-mono font-medium text-white tracking-wider backdrop-blur-xs">
              <i className="fa-solid fa-clock mr-1.5 text-[10px] text-[#fd7302]" aria-hidden="true" />
              {duration}
            </div>
          )}

          {/* Title overlay at bottom */}
          <div className="absolute bottom-0 inset-x-0 p-4 sm:p-5 text-white">
            <span className="inline-block text-[10px] font-bold uppercase tracking-widest text-[#fd7302]">
              Klik for at afspille
            </span>
            <h4 className="mt-1 font-serif text-lg sm:text-xl font-bold line-clamp-2">
              {title}
            </h4>
          </div>
        </div>
      )}
    </div>
  );
}
